import React from "react"
import { Link } from "react-router-dom"

export default function OurFeatures() {
  return (
    <div className="px-[10vw] mt-[5vw]">
      <div className="text-center">
        <div className="flex items-center gap-3 justify-center">
          <hr className="w-10 opacity-50 animate__fadeInUp wow animate__animated" />
          <p>Our Features</p>
          <hr className="w-10 opacity-50 animate__fadeInUp wow animate__animated" />
        </div>
        <h1 className="text-[4vw] font-semibold animate__fadeInUp wow animate__animated">
          Our Journey and Mission
        </h1>
        <p className="animate__fadeInUp wow animate__animated">
          Explore Our Inspirational Journey, Values, and Commitment to Providing
          <br />
          Exceptional SaaS Solutions That Empower Your Business
        </p>
      </div>
      <div className="grid grid-cols-2 mt-[5vw] gap-[3vw]">
        <div className="border border-[#17285a] p-[2vw] md:rounded-3xl rounded-2xl">
          <div className="shadow_1 border border-[#1C244C] p-[2vw] space-y-[2vw] md:rounded-3xl rounded-2xl">
            <h3 className="md:text-[2vw] text-[2.6vw] font-light animate__fadeInUp wow animate__animated">
              Transferring money on x, & tipping.
            </h3>
            <Link
              to={""}
              className="animate__fadeInUp wow animate__animated block text-nowrap text-center px-[3vw] max-w-fit rounded-full py-[1vw] hover:bg-white transition  ease-in-out duration-300 hover:text-black bg-[#02070D] border border-[#0073FF] text-white"
            >
              Start Trading on X
            </Link>
            <div className="relative">
              <div className="before:w-[25vw] before:top-[5vw] before:left-[3vw] before:h-[25vw] before:bg-opacity-20 before:-z-1 before:absolute before:rounded-full before:blur-3xl before:bg-[#1C6FFA] before:block">
                <img
                  src="/images/twitter.webp"
                  alt=""
                  className="flip-animation"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="border border-[#17285a] p-[2vw] md:rounded-3xl rounded-2xl">
          <div className="shadow_1 border border-[#1C244C] p-[2vw] space-y-[2vw] md:rounded-3xl rounded-2xl">
            <h3 className="md:text-[2vw] text-[2.6vw] font-light animate__fadeInUp wow animate__animated">
              Funding your $tweet acc with fiat in the dapp
            </h3>
            <Link
              to={""}
              className="animate__fadeInUp wow animate__animated block text-nowrap text-center px-[3vw] max-w-fit rounded-full py-[1vw] hover:bg-white transition  ease-in-out duration-300 hover:text-black bg-[#02070D] border border-[#0073FF] text-white"
            >
              Join Queue
            </Link>
            <div className="relative">
              <div className="before:w-[25vw] before:top-[5vw] before:left-[3vw] before:h-[25vw]  before:bg-opacity-20 before:-z-1 before:absolute before:rounded-full before:blur-3xl before:bg-[#1C6FFA] before:block">
                <img src="/images/que.webp" alt="" className="flip-animation" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border border-[#17285a] p-[2vw] md:rounded-3xl rounded-2xl mt-[3vw]">
        <div className="grid grid-cols-2  gap-[10vw] shadow_1 border border-[#1C244C] p-[2vw] space-y-[2vw] md:rounded-3xl rounded-2xl">
          <div className="flex items-start justify-center flex-col gap-[2vw]">
            <h3 className="md:text-[3vw] text-[2.6vw] font-light animate__fadeInUp wow animate__animated">
              Airdrop multiple wallets in one tweet.
            </h3>
            <Link
              to={""}
              className="animate__fadeInUp wow animate__animated block px-[3vw] max-w-fit rounded-full py-[1vw] hover:bg-white transition  ease-in-out duration-300 hover:text-black bg-[#02070D] border border-[#0073FF] text-white"
            >
              Start Trading on X
            </Link>
          </div>
          <div className="relative">
            <div className="before:w-[25vw] before:top-[0vw] before:left-[3vw] before:h-[25vw]  before:bg-opacity-20 before:-z-1 before:absolute before:rounded-full before:blur-3xl before:bg-[#1C6FFA] before:block">
              <img
                src="/images/image-3.webp"
                alt=""
                className="flip-animation"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
